import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Image from '../components/Image'
import imgTreneri from '../../assets/img/treneri.jpg'
import imgKacka1 from '../../assets/img/K1.jpg'
import imgKacka2 from '../../assets/img/K2.jpg'
import imgKacka3 from '../../assets/img/K3.jpg'
import imgMichal1 from '../../assets/img/M1.jpg'
import imgMichal2 from '../../assets/img/M2.jpg'
import imgMichal3 from '../../assets/img/M3.jpg'

const Treneri = () => (
  <article className="Trainers">
    <Helmet title="Muvko - Trenéři" />
    <Image src={imgTreneri} alt="Muvko trenéři"/>
    <h1>
      <span>Honza</span>
      <span>Katka</span>
      <span>Michal</span>
    </h1>

    <p>Každý z nás má svůj styl, každý Vám dáváme do těla malinko jinak, ale lásku k pohybu máme společnou a na každém tréninku se pro Vás snažíme ze sebe vydat to nejlepší.</p>

    <section>
      <h2>Katka</h2>

      <Image src={imgKacka1} alt="Kačka v blátě na Spartan Race"/>

      <p>Sport doprovází celý můj život. V dětství jsem si prošla závodním plaváním, atletikou a moderním tancováním. Právě tanec tvořil nejdelší a nejdůležitější část mého sportovního života a dal mi tu nejlepší pohybovou průpravu. Díky tancování jsem získala fyzickou vytrvalost, výbušnost, flexibilitu, ohebnost. Tvrdé tréninky 3x týdně, závody každý víkend, prázdniny travené na soustředěních. Tato chuť dřít, cítit pot v očích a bolest v nohou mi zůstala. Bolest miluju :).</p>

      <Image src={imgKacka2} alt="Kačka na Muvko kempu" />

      <p>S kolegou a dobrým kamarádem Michalem jsme se v roce 2014 rozhodli, že společnou lásku k pohybu a přebytečnou energii bychom rádi předávali dál. MUVKO jsme založili jako otevřené tréninky opravdu pro každého, kdo si chce přijít dát do těla a nebojí se dřiny. Každý člověk, který mi na trénink přijde, je pro mě vzácnost a snažím se mu z mých zkušeností a energie předat co nejvíc, aby tělo i duše byly po tréninku spokojené.</p>

      <Image src={imgKacka3} alt="Kačka v Energymu"/>

      <p>Za ty 4 roky se nám podařilo dát dohromady slušnou základnu lidí, kteří se k nám rádi vrací, jezdí s námi na sportovní kempy a dobrovolně s námi dělají i jiné aktivity. Občas si říkáme muvko rodina, což je něco, co mě na MUVKU fakt baví a vážím si to.</p>

      <p>Vedle fitness dnes miluju běh a zalíbení jsem našla v čím dál tím víc populárnějších extrémních překážkových závodech. Ráda běhám po kopcích, šplhám po laně, nosím těžké pytle a čím déle to trvá, tím líp :). Není proto divu, že moje tréninky jsou víc než o síle o fyzické vytrvalosti a dynamice. Pokud nemáte rádi cardio, asi Vás moje tréninky slušně potrápí. Moje heslo: cardio is hardio :).</p>

      <div className="small">
        <h4>Běh v číslech:</h4>
        <ul>
          <li>5 km: 21:05</li>
          <li>10 km: 42:20</li>
          <li>Půlmaraton: 1:38:50</li>
          <li>Maraton: 3:50:15</li>
        </ul>

        <h5>Některé překážkové závody:</h5>
        <ul>
          <li>Army Run 2015: 3. místo kategorie army ženy</li>
          <li>Spartan Race Super 2016: 2.místo místo open kategorie ženy</li>
          <li>Spartan Race Beast 2016:  2. místo open kategorie ženy</li>
          <li>Spartan Race Super 2017: 2. místo open kategorie ženy </li>
          <li>Spartan Race Ultra Beast 2017: 8. místo kategorie elita ženy</li>
        </ul>

        <h5>Sky up závody:</h5>
        <ul>
          <li>Beskydská sedmička 2016</li>
          <li>Krkonošská padesátka 2017: 2. místo kategorie páry mix</li>
          <li>Redbull 400 2017: 8. místo kategorie ženy A</li>
        </ul>

      </div>

      <h6>Vzdělání:</h6>
      <ul className="small em">
        <li>Magisterské studium na právnické fakultě Univerzity Karlovy v Praze</li>
        <li>Instruktor fitness a Instruktor kondičního posilování - Trenérská škola Ikaros</li>
      </ul>
    </section>

    <section>
      <h2>Michal</h2>

      <Image src={imgMichal1} alt="Kačka v blátě na Spartan Race" />

      <p>I já jsem sportoval od mala. Hrál jsem tenis, fotbal a závodně hokej, kterému jsem se věnoval přes 12 let. Později jsem přesedlal na florbal, kdy jsem dvě sezóny oblékal i extraligový dres. Celkově mě to ale táhlo k více silovějším sportům. Neustále jsem byl v kontaktu s fitness a mým snem bylo v tomto odvětví něco tvořit. MUVKO byla tedy ideální příležitost.</p>

      <Image src={imgMichal2} alt="Kačka v blátě na Spartan Race" />

      <p>Naše tréninky mě hodně nabíjí a baví. Baví mě tvořit náplň tréninku, sledovat lidi když dřou, baví mě pobíhat na flooru a hecovat všechny k ještě větším výkonům. Strašně rád mám taky atmosféru v sále, která je plná energie a dobré nálady. Postupně se MUVKO stalo místem, kde vznikají nová přátelství a lidi si přijdou nejen sáhnout na dno svých momentálních sil, ale taky pokecat a zasmát se (OK, u toho strečinku byste ale zas tak kecat nemuseli ;-)). S trochou nadsázky jsme taková rodinka, jezdíme spolu na campy, pořádáme společně i nějakou tu párty anebo vyjedeme za Prahu na překážkový závod. Líbí se mi ta soudružnost.</p>

      <Image src={imgMichal3} alt="Kačka v blátě na Spartan Race" />

      <p>Chtěli bychom pokračovat dál v tom, co děláme a neustále přicházet s něčím novým a více zapojit lidi do dění okolo, nezabřednout do stereotypu. Hlavní je pro nás především rozdávat radost :).</p>

      <p>KEEP MUUUVIN´</p>

      <h6>Vzdělání:</h6>
      <ul className="small em">
        <li>Magisterské studim na Ostravské univerzitě obor tělovýchova a matematika pro střední školy</li>
        <li>Instruktor fitness, Instruktor kondičního posilování a Osobní trenér kondičního posilování - Trenérská škola Olympia</li>
      </ul>
    </section>
  </article>
)

export default Treneri



// WEBPACK FOOTER //
// ./src/pages/treneri.js